import * as React from "react"

const Copyblock = ({text}) => {
  const onClick = () =>  {
    document.querySelector('.overlay--form').classList.add('active')
  }
  return (
    <p className='button popup--button' role='presentation' onClick={onClick}><span>Sell my car!</span></p>
  )
} 
export default Copyblock
